// extracted by mini-css-extract-plugin
module.exports = {"mySwiper":"styles_mySwiper__gvQOD","swiper-button-prev":"styles_swiper-button-prev__rLQNU","swiper-button-next":"styles_swiper-button-next__wAEqW"};